module.exports = __webpack_public_path__ + "img/bandevideo.8c59a70f.jpg";